import {
  MembershipLevel,
  RoleType,
  GenderType,
  MemberAddress,
  MSSMemberStatus,
  MembershipProductType,
  MemberPhone,
} from '@ace-clublabs/common-membership-api-types';

export interface IGetSuperMemberRequest {
  ClubCode: string;
  MembershipNumber: string;
}

export interface MSSBenefitLevel {
  existingLevel: MembershipLevel;
  pendingLevel?: MembershipLevel;
  effectiveDate?: string;
}

export enum MSSProductStatus {
  EXISTING = 'EXISTING',
  ALLOWED = 'ALLOWED',
  NOT_ALLOWED = 'NOT_ALLOWED',
  INCLUDED = 'INCLUDED',
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
}

export interface MSSProduct {
  type: MembershipProductType;
  status: MSSProductStatus;
  effectiveDate?: string;
}

export interface IGetSuperMemberResponse {
  sessionId?: string | undefined;
  clubCode: string | undefined;
  loggedInCustomerId: string | undefined;
  selectedCustomerId: string | undefined;
  clubRegion: string | undefined;
  joinYear: string | undefined | null;
  members: MSSMembers[] | undefined;
  benefitLevels: MSSBenefitLevel | undefined;
  products: MSSProduct[] | undefined;
  renewexpiredate: string | undefined;
  inArrears: string | undefined;
  inRenewal: string | undefined;
  longevity?: string | undefined;
}

export enum MSSSpinOffStatus {
  SPIN_OFF = 'SPIN_OFF',
  SPIN_UP = 'SPIN_UP',
  NONE = 'NONE',
}

export enum MSSMobileAuthStatus {
  CONSENTED = 'CONSENTED',
  NOT_CONSENTED = 'NOT_CONSENTED',
  NOT_RESPONDED = 'NOT_RESPONDED',
}

export interface MSSPhone extends MemberPhone {
  mobileAuthStatus: MSSMobileAuthStatus;
  isMobilePhone?: boolean;
}

export interface MSSNameChangeRules {
  firstName: boolean;
  middleName: boolean;
  lastName: boolean;
  suffix: boolean;
}

export interface MSSMemberRules {
  viewMembership: boolean;
  changeMembership: boolean;
  makePayment: boolean;
  updateEmail: boolean;
  updatePhone: boolean;
  nameChange: MSSNameChangeRules;
}
export enum IneligibityReasonCode {
  IN_TRANSIT = 200,
  LIMIT_EXCEEDED = 100,
}
export interface PlasticReplacementCard {
  eligible: boolean;
  ineligibityReasonCode: IneligibityReasonCode | null;
}

export interface MSSMembers {
  roleCode?: string;
  roleType: RoleType;
  nameTitle?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  nameSuffix?: string;
  residenceAddress?: MemberAddress;
  mailingAddress?: MemberAddress;
  emailAddress?: string;
  emailStatusCode?: string;
  mobilePhoneNumber?: string; // this will be removed and replaced with phoneNumbers/MSSPhone array
  phoneNumbers?: MSSPhone[];
  rules?: MSSMemberRules;
  status?: MSSMemberStatus;
  customerId?: string;
  membershipCardNumber?: string;
  joinYear?: string | undefined;
  longevity?: string | undefined;
  virtualId?: string;
  secured?: boolean;
  spinOffStatus?: MSSSpinOffStatus;
  plasticReplacementCard: PlasticReplacementCard;
}
